import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { GlobalLeaderboard } from '../../logic/useLeaderboard'
import { PointsLeaderboardEntry } from '@/domain/merkl/types'
import { PointsTable } from './PointsTable'
import { BuddiesTable } from './BuddiesTable'
import { TabSelector } from '@/ui/atoms/tab-selector/TabSelector'
import { useState } from 'react'
interface Props {
  buddiesLeaderboard?: GlobalLeaderboard
  pointsLeaderboard?: PointsLeaderboardEntry[]
}

enum Tabs {
  POINTS = 'Ranking',
  BUDDIES = 'Buddies',
}

export function LeaderboardTable({ buddiesLeaderboard, pointsLeaderboard }: Props) {
  const [activeTab, setActiveTab] = useState<Tabs>(Tabs.POINTS)

  return (
    <Panel.Wrapper className="flex w-full flex-1 flex-col items-start gap-6 px-6 py-4">
      <Typography variant="h3" className="cursor-pointer text-lg" gradient>
        Leaderboard
      </Typography>

      <TabSelector
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={Object.values(Tabs)}
        className="text-lg lg:text-base md:text-sm"
      />

      {activeTab === Tabs.POINTS && <PointsTable pointsLeaderboard={pointsLeaderboard} />}
      {activeTab === Tabs.BUDDIES && <BuddiesTable buddiesLeaderboard={buddiesLeaderboard} />}
    </Panel.Wrapper>
  )
}
